import {HardwareCategoryFields, HardwareGlyph} from "./HardwareGlyph";
import {rimExitDevice} from "./RimExitDevice";
import {leverTrim} from "./LeverTrim";
import {surfaceCloser} from "./SurfaceCloser";
import {surfaceOperator} from "./SurfaceOperator";
import {doorPull} from "./DoorPull";
import {protectionPlate} from "./ProtectionPlate";
import {concealedOHStop} from "./ConcealedOHStop";

export type {HardwareGlyph, GlyphContext, GlyphFootprintContext, GlyphRect, GlyphLeaf, EdgeGlyphContext} from "./HardwareGlyph";

// every category glyph, in match priority order: the first whose `matches` accepts the item
// wins. Add a new product category drawing by appending its glyph here.
const glyphs: HardwareGlyph[] = [
    rimExitDevice,
    leverTrim,
    surfaceCloser,
    doorPull,
    surfaceOperator,
    protectionPlate,
    concealedOHStop,
];

// the category glyph for a hardware item, or null when its category has none (the item then
// draws as the lever / deadbolt / crosshair marker).
export function hardwareGlyphFor(item: HardwareCategoryFields): HardwareGlyph | null {
    return glyphs.find(g => g.matches(item)) ?? null;
}
